import { render, staticRenderFns } from "./coin.vue?vue&type=template&id=5715034a&scoped=true&"
import script from "./coin.vue?vue&type=script&lang=js&"
export * from "./coin.vue?vue&type=script&lang=js&"
import style0 from "./coin.vue?vue&type=style&index=0&id=5715034a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715034a",
  null
  
)

export default component.exports